// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__1dBpm","file":"styles_file__KSTMR"};